// @source app/models/page_customizables/network.rb
export const networkPagesIdentifiersFeaturesMap = {
  homepage: 'homepage',
  feed: 'live_feed',
  users: 'people_directory',
  events: 'events',
  media_center: 'media_center',
  forum: 'forum',
  topics: 'topics',
  news: 'news',
  business_opportunities: 'business_opportunities',
  ventures: 'ventures',
  companies: 'companies',
  memberships: 'memberships',
  donations: 'donations',
  portfolios: 'portfolio',
  public_page: 'public_page',
  my_profile: 'my_profile',
  journeys: 'journeys',
} as const;

// @source: app/models/page_customizables/topic.rb
export const topicPagesIdentifiersFeaturesMap = {
  home: 'home',
  feed: 'feed',
  members: 'members',
  memberships: 'memberships',
  events: 'events',
  news: 'news',
  media_center: 'media_center',
  ventures: 'ventures',
  forum: 'forum',
  jobs: 'jobs',
} as const;

export const networkToTopicIdentifiersMap = {
  ...Object.fromEntries(
    Object.keys(networkPagesIdentifiersFeaturesMap).map((id) => [id, id]),
  ),
  homepage: 'home',
  users: 'members',
  business_opportunities: 'jobs',
};

export type PageIdentifier = keyof typeof networkPagesIdentifiersFeaturesMap;

export const PAGES: Record<
  Uppercase<PageIdentifier>,
  PageIdentifier
> = Object.keys(networkPagesIdentifiersFeaturesMap).reduce(
  (acc, identifier) => {
    acc[identifier.toUpperCase()] = identifier;

    return acc;
  },
  {} as Record<Uppercase<PageIdentifier>, PageIdentifier>,
);
